/* IntactPlus — normalizează afișarea descrierii de produs.
   Nu modifică descrierile din Shopify, doar cum sunt randate în pagină:
     - linie scurtă îngroșată            -> titlu de secțiune (h2)
     - rânduri cu bifă                   -> <ul class="ip-feat">
     - rânduri „Etichetă: valoare"       -> <ul class="ip-spec">
   Un paragraf e rescris doar dacă are cel puțin 2 rânduri cu bifă sau
   cel puțin 4 rânduri de tip „Etichetă: valoare"; restul rămâne neatins. */
(function () {
  var MARK = /^\s*(?:✔️|✔|✅|✓)\s*/;
  var LABEL = /^\s*([^:<>]{2,45}):\s*(\S.*)$/;

  /* --- împarte un paragraf la <br> în fragmente ---------------------------- */
  function splitLines(p) {
    var lines = [];
    var current = document.createDocumentFragment();

    Array.prototype.forEach.call(p.childNodes, function (node) {
      if (node.nodeName === 'BR') {
        lines.push(current);
        current = document.createDocumentFragment();
      } else {
        current.appendChild(node.cloneNode(true));
      }
    });
    lines.push(current);

    return lines.filter(function (frag) {
      return frag.textContent.trim();
    });
  }

  /* --- ce fel de rând este ------------------------------------------------- */
  function isBoldOnly(frag) {
    var kids = Array.prototype.filter.call(frag.childNodes, function (n) {
      return n.nodeType !== 3 || n.nodeValue.trim();
    });
    return kids.length === 1 && kids[0].nodeName === 'STRONG' &&
           frag.textContent.trim().length <= 60;
  }

  function classify(frag) {
    var text = frag.textContent.trim();
    if (MARK.test(text)) return 'feat';
    if (isBoldOnly(frag)) return 'head';
    if (LABEL.test(text.replace(/\s+/g, ' '))) return 'spec';
    return 'text';
  }

  /* --- constructori de blocuri --------------------------------------------- */
  function featItem(frag) {
    var li = document.createElement('li');
    li.appendChild(frag);
    var walker = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, null, false);
    var node = walker.nextNode();
    while (node && !node.nodeValue.trim()) node = walker.nextNode();
    if (node) node.nodeValue = node.nodeValue.replace(MARK, '');
    return li;
  }

  function specItem(frag) {
    var li = document.createElement('li');
    var m = frag.textContent.replace(/\s+/g, ' ').trim().match(LABEL);
    if (!m) { li.appendChild(frag); return li; }

    var label = document.createElement('strong');
    label.textContent = m[1].trim().replace(/:$/, '') + ':';
    var value = document.createElement('span');
    value.textContent = m[2].trim();
    li.appendChild(label);
    li.appendChild(value);
    return li;
  }

  /* --- rescrie un paragraf structurat -------------------------------------- */
  function rebuild(p) {
    var lines = splitLines(p);
    if (lines.length < 2) return false;

    var kinds = lines.map(classify);
    var feats = kinds.filter(function (k) { return k === 'feat'; }).length;
    var specs = kinds.filter(function (k) { return k === 'spec'; }).length;
    if (feats < 2 && specs < 4) return false;

    var out = document.createDocumentFragment();
    var list = null, listKind = null;

    function closeList() { list = null; listKind = null; }

    lines.forEach(function (frag, i) {
      var kind = kinds[i];

      if (kind === 'feat' || kind === 'spec') {
        if (listKind !== kind) {
          closeList();
          list = document.createElement('ul');
          list.className = kind === 'feat' ? 'ip-feat' : 'ip-spec';
          listKind = kind;
          out.appendChild(list);
        }
        list.appendChild(kind === 'feat' ? featItem(frag) : specItem(frag));
        return;
      }

      closeList();

      if (kind === 'head') {
        var h = document.createElement('h2');
        h.innerHTML = frag.firstElementChild.innerHTML;
        out.appendChild(h);
      } else {
        var para = document.createElement('p');
        para.appendChild(frag);
        out.appendChild(para);
      }
    });

    p.parentNode.replaceChild(out, p);
    return true;
  }

  /* --- paragrafe de un singur rând ------------------------------------------ */
  function rebuildSingle(p) {
    var frag = splitLines(p)[0];
    if (!frag) return false;
    var kind = classify(frag);

    if (kind === 'head') {
      var h = document.createElement('h2');
      h.innerHTML = frag.firstElementChild.innerHTML;
      p.parentNode.replaceChild(h, p);
      return true;
    }

    if (kind === 'feat') {
      var ul = document.createElement('ul');
      ul.className = 'ip-feat';
      ul.appendChild(featItem(frag));
      p.parentNode.replaceChild(ul, p);
      return true;
    }

    return false;
  }

  /* --- rulare ---------------------------------------------------------------- */
  function upgrade(root) {
    Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (p) {
      if (!p.parentNode) return;
      if (p.querySelector('br')) rebuild(p);
      else rebuildSingle(p);
    });
  }

  function run() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[class*="product_description"]'),
      upgrade
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();